<mat-form-field [attr.data-form-field]="field" [appearance]="appearance" [formGroup]="formGroup" class="full-width">
  @if (icon) {
    <mat-icon matPrefix>{{ icon }}</mat-icon>
  }
  @if (label) {
    <mat-label class="label">{{ label | translate }}</mat-label>
  }

  <input
    matInput
    [formControlName]="field"
    [readonly]="readonly"
    [required]="mandatory"
    [min]="minValue"
    [max]="maxValue"
    [id]="field + '-input'"
    [matDatepicker]="datePicker"
    (keydown.enter)="keydownEnter($event)"
    />
  <mat-datepicker-toggle matSuffix [for]="datePicker"></mat-datepicker-toggle>
  <mat-datepicker #datePicker></mat-datepicker>

  <!-- The mat-error tag HAS to be directly inside the mat-form-field otherwise it doesn't render properly if inside the ng-container -->
  <mat-error>
    @for (e of displayedErrors(); track e) {
      <span [attr.data-form-field-error]="e.error">
        {{ e.messageKey | translate : formGroup.controls[field].getError(e.error) }}
      </span>
    }
  </mat-error>
  @if (hint) {
    <mat-hint>{{ hint }}</mat-hint>
  }
</mat-form-field>
